module.exports = __webpack_public_path__ + "static/20-033fb75eba8ba52ee518a5dc11395c9c.jpg";